import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-navigation-header',
  templateUrl: './navigation-header.component.html',
  styleUrls: ['./navigation-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationHeaderComponent {
  @Input() header = '';
  @Input() icon = '';
  /** Useful to handle special cases */
  @Input() templateRef?: TemplateRef<unknown>;
}
